import { SubscriberGroupItemWire } from 'app/area/subscriber-groups/list/types';
import { SubscriberGroupsListItem } from 'app/area/subscriber-groups/list/types-store';
import { parseAsDateUTC } from 'app/infrastructure/data/date';

export const mapList = (listWire: SubscriberGroupItemWire[]): SubscriberGroupsListItem[] => {

  if ((listWire?.length ?? 0) === 0) {
    return [];
  }

  return listWire.map(item => ({
    id: item.v,
    description: item.d,
    selfService: item?.selfService,
    disabled: parseAsDateUTC(item?.disabled)
  }));
};
